import React from 'react';
import {getTeamLogo} from "../../../../static/logos/TeamLogos";
import clubInfo from "../../../../static/clubInfo";
import {useLeagueSelection} from "../../../../hooks/useLeagueSelection";
import { MoonLoader } from 'react-spinners';
import './Table.css';

const BigTable = ({data, title, isLoading}) => {
    const { leagueLevel } = useLeagueSelection();
    const Standings = data;
       return (
<div className={`big-table ${leagueLevel === "1" ? "big-table-first" : leagueLevel === "2" ? "big-table-second" : ""}`}>
            <h1>{title}</h1>
{isLoading ? <div className="big-table__loading-spinner"><MoonLoader color="#36d7b7" size={50} /></div>
            :
            <>

            <div className="big-table__table-wrapper">
                <table className="big-table__content">
                            <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Spiele</th>
                            <th>S</th>
                            <th>U</th>
                            <th>N</th>
                            <th>Punkte</th>
                            <th>D</th>
                            <th>BP</th>
                            <th>BV</th>
                            <th>BN</th>
                            <th>Pkt</th>
                        </tr>
                    </thead>
                    <tbody>
                    {Standings.map((team) => (
                        <tr key={team.club}>
                            <td></td>
                            <td>{team.standing}</td>
                            <td>
                                <img src={getTeamLogo(team.club)} alt={team.club}/>
                            </td>
                            <td
                            >
                                <span>
                                    {clubInfo.find(club => club.clubee_name === team.club)?.details.club_short}
                                </span>
                            </td>
                            <td>{team.games}</td>
                            <td>{team.win}</td>
                            <td>{team.undecided}</td>
                            <td>{team.lost}</td>
                            <td>{team.points_made}:{team.points_conceded}</td>
                            <td>{Number(team.points_made)-Number(team.points_conceded)}</td>
                            <td>{Number(team.offensive_bonus)+Number(team.defensive_bonus)}</td>
                            <td>{team.offensive_bonus}</td>
                            <td>{team.defensive_bonus}</td>
                            <td>{team.points}</td>
                        </tr>
                    ))}
                    </tbody>

                </table>
            </div>
            </>
            }
        </div>
    );
}

export default BigTable;
